module.exports = __webpack_public_path__ + "static/media/013.5f1b5430.jpg";